import React, { useContext } from 'react';
import { useHistory, useLocation } from 'react-router';
import {
  CanAccessPartnerData,
  ViewerContext,
} from '../providers/ViewerContextProvider';
import { Communicator } from '../tools/Communication';

interface IUrlParameters {
  match: {
    params: {
      storeId: string;
      brandId: string;
    };
  };
}

interface StoreInfo {
  externalMerchantId: string;
}

function useQueryParams() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default function PickpackRedirect(urlParams: IUrlParameters) {
  const viewer = useContext(ViewerContext);
  const history = useHistory();
  const allowedToAccess = CanAccessPartnerData(viewer);
  const { storeId, brandId } = urlParams.match.params;
  const queryParams = useQueryParams().toString();
  if (allowedToAccess && storeId != null && brandId != null) {
    history.replace(
      `/partner/brand/${brandId}/store/${storeId}?${queryParams}`,
    );
  } else if (allowedToAccess && storeId != null) {
    Communicator.Get('/Merchant/GetExternalMerchantIdByExternalStoreId', {
      externalStoreId: storeId,
    })
      .then((result) => result.json())
      .then((storeInfo: StoreInfo) => {
        history.replace(
          `/partner/brand/${storeInfo.externalMerchantId}/store/${storeId}?${queryParams}`,
        );
      });
  } else if (allowedToAccess && urlParams.match.params.brandId != null) {
    history.replace(
      `/partner/brand/${urlParams.match.params.brandId}?${queryParams}`,
    );
  } else if (!allowedToAccess) {
    history.replace(`/partner/merchants?${queryParams}`);
  }

  return <div />;
}
